// Relative luminance of red, blue, and green according to W3

import { RGB } from './color'

// The relative color luminance of red, green, and blue as defined by W3
// https://www.w3.org/TR/WCAG21/#dfn-relative-luminance
const colorLuminance = {
  red: 0.2126,
  green: 0.7152,
  blue: 0.0722,
}

// Normalize the color to a value between 0 and 1 as defined by W3. The normalization calculations
// use a piecewise function that normalizes colors differently based on the light intensity.
// Read more about this here: https://www.w3.org/TR/WCAG21/#dfn-relative-luminance
const normalizedColor = (color: number) => {
  const colorBut0to1 = color / 255
  const lowLightIntensity = colorBut0to1 <= 0.0405
  return lowLightIntensity ? colorBut0to1 / 12.92 : Math.pow((colorBut0to1 + 0.055) / 1.055, 2.4)
}

// Get the relative brightness of any color, normalized to 0 for darkest black and 1 for the lightest light.
// Read more about this here: https://www.w3.org/TR/WCAG21/#dfn-relative-luminance
export const relativeLuminance = ({ r, g, b }: RGB) => {
  return (
    colorLuminance.red * normalizedColor(r) +
    colorLuminance.green * normalizedColor(g) +
    colorLuminance.blue * normalizedColor(b)
  )
}
